import { z } from "zod";
import { BaseStatisticsOutputItemSchema } from "@/Schemas/Statistics/BaseStatisticsOutputItem";

export const StatisticsStateOutputSchema = z.object({
    masterItems: z.array(BaseStatisticsOutputItemSchema),
    items: z.array(BaseStatisticsOutputItemSchema),
});

export type StatisticsStateOutput = z.infer<typeof StatisticsStateOutputSchema>;